import { render, staticRenderFns } from "./PNLChart.vue?vue&type=template&id=665f965d&lang=pug"
import script from "./PNLChart.vue?vue&type=script&lang=js"
export * from "./PNLChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports